/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-container fluid grid-list-md>
    <v-toolbar height="44px" class="sub-header" id="toolbar">
      <v-toolbar-title class="body-2">Temperature corrected PR</v-toolbar-title>
      <v-spacer></v-spacer>
         <v-tooltip bottom>
       <v-btn icon slot="activator" v-on:click="refresh">
        <v-avatar :tile="tile" :size="avatarSize" class="avatar-bg">
          <v-icon>refresh</v-icon>
        </v-avatar>
      </v-btn>
        <span>Refresh</span>
         </v-tooltip>
    </v-toolbar>
    <div>
      <v-data-table :headers="headers" :items="dataSet" :pagination.sync="pagination" hide-actions class="elevation-1" :loading="isLoading">
        <template slot="items" slot-scope="props">
          <td v-for="x in headers" :key="x.value">{{ props.item[x.value] }}</td>
          <td><v-tooltip bottom><v-icon slot="activator" :color="props.item.hasIssue ?  'orange':'green'">info</v-icon><span>{{props.item.status}}</span></v-tooltip></td>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
      </div>
    </div>
  </v-container>
</template>

<script>
import { EventBus } from '@/services/event-bus'
import PrApi from '@/services/TempBasedPr'

export default {
  data () {
    return {
      search: '',
      pagination: {
        rowsPerPage: 15
      },
      selected: [],
      headers: [
        {
          text: 'Block',
          value: 'block_name'
        },
        {
          text: 'Inverter Room',
          value: 'room_name'
        },
        {
          text: 'Inverter',
          value: 'inverter_name'
        },
        {
          text: 'AC Power (kW)',
          value: 'ac_power',
          sortable: false
        },
        {
          text: 'Irr. Power (kW)',
          value: 'irr_based_power',
          sortable: false
        },
        {
          text: 'Temp Power (kW)',
          value: 'temp_corrected_power',
          sortable: false
        },
        
        // {
        //   text: 'Simulated Power (kW)',
        //   value: 'simulated_power',
        //   sortable: false
        // },
        {
          text: 'Assumed PR  (%)',
          value: 'assumed_pr',
          sortable: false
        },
        {
          text: 'Actual PR (%)',
          value: 'actual_pr',
          sortable: false
        }
      ],
      dataSet: [],
      interval: null,
      isLoading: false
    }
  },
  mounted () {
    this.getPr()
    const self = this
    this.interval = setInterval(function () {
      self.getPr()
    }, 60000)
  },
  destroyed () {
    if (this.interval !== null) {
      clearInterval(this.interval)
    }
  },
  methods: {
    async getPr () {
      this.isLoading = true
      let data = await PrApi.getPr(102)
      this.isLoading = false
      if (data.status === 200) {
        this.dataSet = data.data.message
      }
    },
    refresh() {
      this.getPr();
    },
    tableData(data) {
      // this.headers = this.createHeader(data[0]);
      this.dataSet = data
    },
    createHeader (data) {
      let tempHeader = []
      Object.keys(data).forEach((key) => {
        tempHeader.push({
          text: key,
          value: key
        })
      })
      return tempHeader
    }
  },
  watch: {
    dataSet () {
      this.tableData(this.dataSet)
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.dataSet.length / this.pagination.rowsPerPage)
    }
  }
}
</script>
